import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  border: none;
  @media only screen and (max-width: 800px) {
    width: 150px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  font-size: 16px;
  font-family: "Montserrat";
  border-radius: 16px;
  border: 2px solid var(--purple);
  background-color: var(--purple);
  color: white;
  @media only screen and (max-width: 800px) {
    font-size: 14px;
  }
  &::placeholder {
    color: white; /* Cor do texto do placeholder */
    opacity: 1; /* Garante que a cor seja aplicada corretamente */
  }
`;

export const SearchDiv = styled.div`
    display: flex;
    justify-content: space-evenly;
`;


export const ResultsList = styled.ul`
  position: absolute;
  top: 100%; /* Faz a lista aparecer logo abaixo do input */
  left: 0;
  width: 100%;
  background: white;
  border: none;
  z-index: 1000;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px; /* Limita a altura para evitar que ultrapasse a tela */
`;

export const ResultItem = styled.li`
  padding: 8px;
  color: var(--purple);
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #f0f0f0;
  }
  p {
    font-family: "Montserrat";
  }
  h3 {
    text-transform: uppercase;
    font-family: "Poppins";
    font-weight: 600;
  }
`;

